import { Grid } from '@mui/material';
import { useState } from 'react';
import { acceptWorkAssignment, IWorkAssignmentDTO } from 'wisestep-api';
import { WsButton, WsDataTable } from 'wisestep-base';

import { success } from '../../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../../utils/NotificationStore';
import { StyledFooter } from '../editJobAdminTeam';

interface EditWorkAssignmentTeamProps {
  workAssignment: IWorkAssignmentDTO;
  closeDrawer(): void;
  onWorkAssignmentTeamChange(): void;
}

const EditWorkAssignmentTeam = ({
  workAssignment,
  closeDrawer,
  onWorkAssignmentTeamChange,
}: EditWorkAssignmentTeamProps) => {
  const [selectedTeamId, setSelectedTeamId] = useState<string>();
  const setNotification = useNotificationStore((state) => state.setNotification);

  let teamNames: string[] = [];
  let teamIds: string[] = [];

  const columns = [
    { Header: 'Teams', accessor: 'teamName' },
    { Header: 'Action', accessor: 'action' },
  ];

  if (workAssignment?.assignedToTeams) {
    teamIds = Object.keys(workAssignment?.assignedToTeams);
    teamNames = Object.values(workAssignment?.assignedToTeams);
  }

  const selectTeam = (index: number) => setSelectedTeamId(teamIds[index]);

  const assignTeam = async () => {
    if (workAssignment?.id && selectedTeamId) {
      await acceptWorkAssignment(workAssignment.id, selectedTeamId);
      setNotification(success('Work Assignment Team has been updated'));
      closeDrawer();
      onWorkAssignmentTeamChange();
    }
  };

  const tableData: Record<string, unknown>[] =
    teamNames.length > 0
      ? teamNames.map((element, index) => ({
          id: index,
          teamName: element ?? '',
          action: (
            <WsButton
              variant={teamIds[index] == selectedTeamId ? 'contained' : 'outlined'}
              size="small"
              onClick={() => selectTeam(index)}
            >
              Select
            </WsButton>
          ),
        }))
      : [];

  return (
    <Grid p={2}>
      <WsDataTable
        preSelectedRows={[]}
        columns={columns}
        data={tableData}
        boldItems={['teamName']}
      />

      <StyledFooter>
        <Grid container item justifyContent="flex-end" pr={1} py={1}>
          <WsButton
            variant="contained"
            size="large"
            disabled={selectedTeamId == null}
            onClick={assignTeam}
          >
            Assign
          </WsButton>
        </Grid>
      </StyledFooter>
    </Grid>
  );
};

export default EditWorkAssignmentTeam;
